import { api, ApiError } from "@/api/api";
import { MasterCombinationWithRelations } from "@/api/master-combinations-types";
import { PaginatedData, PaginationParams } from "@/api/utils";
import { useQuery } from "@tanstack/react-query";

export function useMasterCombinations(params?: PaginationParams) {
  return useQuery<PaginatedData<MasterCombinationWithRelations>, ApiError>({
    queryKey: ["GET", "master-combinations", params?.pageSize, params?.page],
    queryFn: () => api.masterCombinations.get(params),
  });
}

export function useAllMasterCombinations() {
  return useMasterCombinations({ page: 0, pageSize: 1000 });
}
